// extracted by mini-css-extract-plugin
module.exports = {"pricing__heading":"Pricing-module--pricing__heading--3bxcP","pricing__title":"Pricing-module--pricing__title--1giwG","pricing__offers":"Pricing-module--pricing__offers--bDO3Q"};